import { DownOutlined, PoweroffOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons'
import { Dropdown, Avatar, Space } from 'antd'
import React from 'react'
import { useNavigate } from "react-router-dom"
import { storeItem } from 'utils/tokenStore'
import { useTranslation } from "react-i18next"

const Userbox = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const menuItem = {
    items: [
      {
        key: "profile",
        icon: <UserOutlined />,
        label: t("Profile")
      },
      {
        key: "settings",
        icon: <SettingOutlined />,
        label: t("Settings")
      },
      {
        key: "logout",
        icon: <PoweroffOutlined />,
        label: t("LogOut")
      }
    ],
    onClick: (e) => {
      switch(e.key){
        case "profile":
          navigate('/dashboard/profile')
          break
        case "settings":
          navigate('/dashboard/settings')
          break
        case "logout":
          storeItem("LOGIN_TOKEN", "")
          storeItem("Username", "")
          storeItem("TYPE", "")
          window.location.reload()
          break
        default: 
      }
    }
  }

  return (
    <Dropdown menu={menuItem} trigger={'hover'}>
      <a onClick={(e) => e.preventDefault()}>
        <Space>
          <Avatar size={32} icon={<UserOutlined />} />
          <DownOutlined />
        </Space>
      </a>
    </Dropdown>
  )
}

export default Userbox